import { __module as i } from "./index773.js";
var k = i.exports, o;
function O() {
  return o ? i.exports : (o = 1, (function(u, p) {
    (function(r, t) {
      u.exports = t();
    })(k, (function() {
      var r = "week", t = "year";
      return function(v, d, a) {
        var n = d.prototype;
        n.week = function(e) {
          if (e === void 0 && (e = null), e !== null) return this.add(7 * (e - this.week()), "day");
          var s = this.$locale().yearStart || 1;
          if (this.month() === 11 && this.date() > 25) {
            var h = a(this).startOf(t).add(1, t).date(s), l = a(this).endOf(r);
            if (h.isBefore(l)) return 1;
          }
          var c = a(this).startOf(t).date(s).startOf(r).subtract(1, "millisecond"), f = this.diff(c, r, !0);
          return f < 0 ? a(this).startOf("week").week() : Math.ceil(f);
        }, n.weeks = function(e) {
          return e === void 0 && (e = null), this.week(e);
        };
      };
    }));
  })(i), i.exports);
}
export {
  O as __require
};
